/* eslint-disable func-style */
const RightPanel = () => import('../components/RightPanel');
const TransferRecord = () => import('../pages/RefundToSave/TransferRecord');
const TransferDetail = () => import('../pages/RefundToSave/TransferDetail');
const TransferRecordDetail = () => import('../pages/RefundToSave/TransferRecordDetail');

const RefundToSave = [
	{
		path: '/RefundToSave',
		name: 'RefundToSave',
		component: () => import('@/pages/RefundToSave/RefundToSave'),
		children: [
			{
				path: '/RefundToSaveRightPanel',
				name: 'RefundToSaveRightPanel',
				component: RightPanel,
				children: [
					{
						path: '/RefundToSaveDetail/:rowData',
						name: 'RefundToSaveDetail',
						component: () => import('@/pages/RefundToSave/RefundToSaveDetail'),
						meta: { parent: '/RefundToSave' },
					},
				],
			},
		],
	},
	{
		path: '/TransferRecord',
		name: 'TransferRecord',
		component: TransferRecord,
	},
	{
		path: '/TransferDetail',
		name: 'TransferDetail',
		component: TransferDetail,
	},
	{
		path: '/TransferRecordDetail',
		namme: 'TransferRecordDetail',
		component: TransferRecordDetail,
	},
	{
		path: '/DeductionRecord',
		name: 'DeductionRecord',
		component: () => import('@/pages/DeductionRecord/DeductionRecord'),
	},
	{
		path: '/DeductionDetail',
		name: 'DeductionDetail',
		component: () => import('@/pages/DeductionRecord/DeductionDetail'),
		children: [
			{
				path: '/DeductionDetailRightPanel',
				name: 'DeductionDetailRightPanel',
				component: RightPanel,
				children: [
					{
						path: '/DeductionDetailPanel/:rowData',
						name: 'DeductionDetailPanel',
						component: () => import('@/pages/DeductionRecord/DeductionDetailPanel'),
						meta: { parent: '/DeductionDetail' },
					},
				],
			},
		],
	},
];

export default RefundToSave;
